<gd-dialog-container (close)="cancel()" [class]="size">
  <gd-stores-list-modal-content
    [stores]="storesList$ | async"
    [isLoading]="isStoresListLoading$ | async"
    [title]="'txt_product_template_store_selection_modal_title' | translate"
    [subtitle]="'txt_product_template_store_selection_modal_subtitle' | translate: { templateName: templateName }"
    (storeSelect)="selectStore($event)"
    (closeModal)="cancel()"
  >
  </gd-stores-list-modal-content>
</gd-dialog-container>
